export const screensOverrides = {
  '2xl': '1400px',
}
